<template>
  <div>
    <v-alert
      prominent
      type="info"
      text
      class="mb-4"
      v-if="$_hasRole('student')"
    >
      <v-row align="center">
        <v-col class="grow">
          Du kannst hier eine aktuelle stätigung als PDF-Datei herunterladen.
        </v-col>
        <v-col class="shrink">
          <ReportButton
            resource="report/schoolconfirmation"
            :parameters="{
              type: 'student',
              target: 'email',
              year: 'current',
              id: $_profilePerson.id,
            }"
            text
            color="info"
            >Schulbestätigung</ReportButton
          >
        </v-col>
      </v-row>
    </v-alert>
    <v-alert
      prominent
      type="info"
      text
      class="mb-4"
      v-if="$_hasRole('teacher') && $_isPerson(person)"
    >
      <v-row align="center">
        <v-col class="grow">
          Du kannst hier eine aktuelle Anstellungsbestätigung als PDF-Datei
          herunterladen.
        </v-col>
        <v-col class="shrink">
          <ReportButton
            resource="report/teacherconfirmation"
            :parameters="{
              type: 'teacher',
              target: 'email',
              id: $_profilePerson.id,
            }"
            text
            color="info"
            >Anstellungsbestätigung</ReportButton
          >
        </v-col>
      </v-row>
    </v-alert>
    <PersonProfile :person="person" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ReportButton from "@/components/ReportButton.vue";

import PersonProfile from "common/components/Person/PersonProfile.vue";

export default defineComponent({
  name: "PersonStudentInfo",
  components: { ReportButton, PersonProfile },
  props: ["person"],
});
</script>
